import { Route as ngRoute, Routes } from '@angular/router';

import { AuthenticationGuard } from './authentication/authentication.guard';
import { AppLayoutComponent } from './layouts/app/app-layout.component';
import { BaseLayoutComponent } from './layouts/base/base-layout.component';
import { CheckoutLayoutComponent } from './layouts/checkout/checkout-layout.component';

/**
 * Provides helper methods to create routes.
 */
export class Route {
    // -----------------------------------------------------------------------------------------------------
    // @ PUBLIC STATIC METHODS
    // -----------------------------------------------------------------------------------------------------

    /**
     * Creates routes using the shell component and authentication.
     * @param routes The routes to add.
     * @return The new route using shell as the base.
     */
    static withBaseLayoutAndAuthentication(routes: Routes): ngRoute {
        return {
            path: '',
            component: BaseLayoutComponent,
            children: routes,
            canActivate: [AuthenticationGuard]
        };
    }

    /**
     * Creates routes using the mobile app layout (bottom tab bar) and authentication.
     * @param routes The routes to add.
     * @return The new route using the app layout as the base.
     */
    static withAppLayoutAndAuthentication(routes: Routes): ngRoute {
        return {
            path: '',
            component: AppLayoutComponent,
            children: routes,
            canActivate: [AuthenticationGuard]
        };
    }

    static withCheckoutLayoutAndAuthentication(routes: Routes): ngRoute {
        return {
            path: '',
            component: CheckoutLayoutComponent,
            children: routes,
            canActivate: [AuthenticationGuard]
        };
    }

    /**
     * Creates routes using the shell component.
     * @param routes The routes to add.
     * @return The new route using shell as the base.
     */
    static withBaseLayout(routes: Routes): ngRoute {
        return {
            path: '',
            component: BaseLayoutComponent,
            children: routes
        };
    }
}
